import React, {Suspense} from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ZonesList from '../../pages/difacto/zones/ZonesList';
import EditZone from '../../pages/difacto/zones/EditZone';
import Zone from "../../pages/difacto/zones/Zone";
import NewZone from "../../pages/difacto/zones/NewZone";

function Zones(props) {
  const { path } = useRouteMatch();
  const { t } = useTranslation();

	return (
    <Suspense fallback={<div>{t('loading')}...</div>}>
      <Switch>
        <Route exact path={`${path}`} component={ZonesList}/>
        <Route path={`${path}/new`} component={NewZone}/>
        <Route path={`${path}/:zoneId/edit`} component={EditZone}/>
        <Route path={`${path}/:zoneId`} component={Zone}/>
      </Switch>
    </Suspense>
	)
}

export default Zones
